import { gsap } from 'gsap'

const elSwupOverlay = document.querySelector('.js-overlay-loader')

// export const defaultTransition = {
// 	from: '(.*)',
// 	to: '(.*)',
// 	out: async () => {
// 		console.log('Running default transition out animation...')

// 		// polyong hide
// 		await gsap.fromTo(
// 			elSwupOverlay,
// 			{ display: 'block', opacity: 1, clipPath: 'polygon(0 0, 100% 0, 100% 0%, 0% 0%)' },
// 			{ clipPath: 'polygon(0 0, 100% 0, 100% 200%, 0% 100%)', duration: 0.5 },
// 		)
// 	},
// 	in: async () => {
// 		console.log('Running default transition in animation...')

// 		await gsap.fromTo(
// 			elSwupOverlay,
// 			{ display: 'block', opacity: 1, clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0% 100%)' },
// 			{
// 				clipPath: 'polygon(0 150%, 100% 100%, 100% 200%, 0% 100%)',
// 				duration: 0.5,
// 				delay: 0.2,
// 				onComplete: () => {
// 					gsap.set(elSwupOverlay, { display: 'none' })
// 				},
// 			},
// 		)
// 	},
// }

export const defaultTransition = {
	from: '(.*)',
	to: '(.*)',
	out: async () => {
		await gsap.fromTo(elSwupOverlay, { display: 'block' }, { opacity: 1, duration: 0.1 })
		// await gsap.to('#swup', { opacity: 0, duration: 0.25 })
	},
	in: async () => {
		await gsap.fromTo(
			elSwupOverlay,
			{ opacity: 1 },
			{
				opacity: 0,
				delay: 0.3,
				duration: 0.3,
				onComplete: () => {
					gsap.set(elSwupOverlay, { display: 'none' })
				},
			},
		)

		// await gsap.fromTo(
		// 	'#swup',
		// 	{ opacity: 0 },
		// 	{ opacity: 1, duration: 0.25 }
		// )
	},
}
